import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
  width: 100%;
  max-width: 720px;
  height: 680px;
  background-color: #f8f9fa;
  border-radius: 12px;
  padding: 40px 70px 20px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 35px auto 0 auto;
`;

const TextContainer = styled.div`
  max-height: 450px;
  overflow-y: null;
  font-size: 14px;
  color: #333;
  margin-bottom: 20px;
  line-height: 1.5;
  text-align: left;

  h4 {
    font-weight: bold;
  }

  p {
    margin-bottom: 10px;
  }

  b {
    font-weight: bold;
  }

  i {
    font-style: italic;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  position: fixed;
  top: 810px;
  gap: 20px;
`;

const Button = styled.button`
  background-color: #6ab292;
  color: white;
  font-size: 16px;
  font-weight: 500;
  border: none;
  border-radius: 8px;
  padding: 8px 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);

  &:hover {
    background-color: #5a9e82;
  }
`;

const VideoComponent = () => {
  const navigate = useNavigate();

  const handleBefore = () => {
    navigate('/Video');
  };

  const handleNext = () => {
    navigate('/TermoCooperacao');
  };

  return (
    <Container>
      <TextContainer>
        <p>
          <b>A Tecnologia de Gestão para Núcleos de Educação Permanente em Saúde (NEPS)</b>, em seu módulo de estágios, visa a regulação do acesso aos campos de estágios e atividades práticas dos cursos da área da saúde nas instituições de saúde. Para tanto, promoverá o ranqueamento de instituições públicas e privadas, no que concerne a utilização dos diferentes cenários de prática.
        </p>
        <p>
          Entende-se como <i>estágio obrigatório/atividade prática</i>, o ato educativo, supervisionado por docente, desenvolvido nos diferentes cenários de trabalho nas instituições de saúde, buscando formar os alunos que estejam frequentando o ensino regular nas instituições de educação superior ou de nível médio.
        </p>
        <p>
          Já <i>estágio supervisionado</i> é aquele definido no projeto político pedagógico do curso, cuja carga horária é regular e obrigatória como requisito para aprovação e obtenção de diploma. Nos estágios supervisionados, a supervisão docente poderá ser indireta, com a supervisão direta dos profissionais do campo.
        </p>
        <p>
          <b>Internato médico</b>, são as atividades dos alunos da medicina, nas suas últimas fases, em que desenvolvem atividades voltadas ao aprimoramento de sua formação nas grandes especialidades: médica, cirúrgica, obstetrícia/ginecologia e pediatria.
        </p>
        <p>
          <b>Aula prática</b> é entendida como aula em campo, em que o professor ministra a aula e os alunos tem oportunidade de realizar treinamento em loco.
        </p>
        <p>
          Entende-se como <b>coordenador de Instituição de Ensino (IE)</b>, o docente/profissional responsável pelo cadastro da instituição de ensino, como <b>coordenador de estágio</b>, o responsável do curso pela solicitação das vagas de estágio obrigatório/atividade prática, estágio supervisionado e internato, e como <b>gestor do estabelecimento de saúde (ES)</b> o profissional do estabelecimento de saúde responsável por analisar e liberar as solicitações de vagas demandas pelas IES.
        </p>
      </TextContainer>
      
      <ButtonContainer>
        <Button onClick={handleBefore}>
          &lt; Voltar
        </Button>
        <Button onClick={handleNext}>
          Próximo &gt;
        </Button>
      </ButtonContainer>
    </Container>
  );
};

export default VideoComponent;
